module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAMAAADto6y6AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABIUExURUxpcf///////////////////////////////////////////////////////////////////////////////////////////w+vxkAAAAAXdFJOUwBwHLYqAvlr4wxO89TZmxry/En9Qm7+JahUSQAAAJRJREFUKM/Vj1kSxCAIRDFq0LhlHe9/0wGSqag3mP7A8jVCC3BrQp1CSBonaFXyVh9tubx8WWujdfnx66idjuvp//AtKuO9UVEceVN4zoz27rI48zTek5mf78KTnUw5OQ+2EZGzTXJE2xo2SqumqrpPgSKkIVE1vWEIJQhUfW94QgE4NwwS9meGq9WNhrDduX00mH0Bbb0RMutEUdUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expanded-project-responsive-path-1@2x.png
// module id = 258
// module chunks = 0